import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTimeHelperService } from './date-time-helper.service';

/**
 * Custom pipe to format dates with ordinal suffixes (st, nd, rd, th)
 * Usage: {{ dateValue | dateWithOrdinal:'EEE, d MMM y, HH:mm' }}
 */
@Pipe({
  name: 'dateWithOrdinal',
  standalone: true
})
export class DateWithOrdinalPipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en-GB');
  private readonly dateTimeHelper = new DateTimeHelperService();

  transform(value: any, format: string = 'EEE, d MMM y, HH:mm'): string | null {
    if (!value) return null;
    
    // Use DatePipe to format the date
    const formatted = this.datePipe.transform(value, format);
    if (!formatted) return null;
    
    // Add ordinal suffix to the day number
    return this.dateTimeHelper.addOrdinalToDateString(formatted);
  }
}

